import styled, { css } from 'styled-components'

export const Note = styled.div`
  position: absolute;
  left: var(--space-n300);
  top: var(--space-n800);

  padding: var(--space-100);

  background: var(--bg-critical);
  text-transform: uppercase;
  color: var(--color-gray-100);
  font-size: var(--font-size-100);
  font-weight: var(--font-weight-semibold);
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
`

type ContainerProps = {
  $inline?: boolean
}

export const Container = styled.div<ContainerProps>`
  position: relative;

  outline: 1px dashed transparent;
  outline-offset: var(--space-200);
  cursor: help;

  ${({ $inline }) =>
    $inline &&
    css`
      display: inline;
    `};

  &:hover {
    outline-color: var(--bg-critical);

    ${Note} {
      opacity: 1;
    }
  }
`
